import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

import type MobileMetricsController from 'webapp/controllers/mobile/metrics';

import MetricSetup from 'webapp/models-custom/metric-setup';

import type MetricDetailsService from 'webapp/services/metric-details';

// A deeplink (/m/metrics?state=…) opens the metric details drawer over the page.
export default class MobileMetricsRoute extends Route {
	@service('infolayer') declare infolayerService: Service.Infolayer;
	@service('metric-details') declare metricDetailsService: MetricDetailsService;
	@service('navigation') declare navigationService: Service.Navigation;

	// A deeplink can also arrive while the page is open, and only a refresh runs setupController again.
	override queryParams = {
		state: { refreshModel: true },
	};

	override beforeModel(): Promise<unknown> {
		return this.navigationService.initialRequestsPromise;
	}

	override setupController(controller: MobileMetricsController, model: unknown): void {
		super.setupController(controller, model);

		if (controller.state) {
			const metricSetupData = this.metricDetailsService.deserializeMetricSetup(
				controller.state,
			);

			if (metricSetupData) {
				this.metricDetailsService.openMetricDetailsDrawer(
					{ metricSetup: new MetricSetup(metricSetupData) },
					'mobile_deeplink',
				);
			} else {
				this.infolayerService.error('Invalid metric link.');
			}

			// Cleared here, it joins this transition's URL update: a later query-param-only transition would close all popups.
			controller.state = null;
		}
	}
}
